import React from "react";
import RoleBasedComponent from "../../components/RoleBasedComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Paths } from "../../router/Paths";
import { setOptionEdit } from "../../reducer/tourEditReducer";

export default function ManageProductoptionDataSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsSetup, {
      state: { optionData },
    });
  };
  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Options Details</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Title</p>
              <p className="text-secondary capitalize">
                {optionData?.title ?? "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Reference Code</p>
              <p className="text-secondary capitalize">
                {optionData?.referenceCode ?? "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Description</p>
              <p className="text-secondary">
                {optionData?.description ?? "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Maximum Group Size</p>
              <p className="text-secondary">
                {optionData?.maxGroupSize ?? "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Guide Languages</p>
              {optionData?.guideLanguages &&
              optionData.guideLanguages.length > 0 ? (
                optionData.guideLanguages.map((item: string, index: number) => (
                  <p key={index} className="text-secondary capitalize">
                    {item}
                  </p>
                ))
              ) : (
                <p className="text-secondary capitalize">N/A</p>
              )}
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Is it Private Activity ?</p>
              <p className="text-secondary">
                {optionData?.isPrivateActivity ? "Yes" : "No"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Guide Material</p>
              <p className="text-secondary">
                {optionData?.guideMaterial ?? "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Can Customer Skip Line?</p>
              <p className="text-secondary">
                {optionData?.customerSkipLine ? "Yes" : "No"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Line To Skip</p>
              <p className="text-secondary">
                {optionData?.lineToSkip ?? "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold capitalize">
                Is the activity wheelchair accessible?
              </p>
              <p className="text-secondary">
                {optionData?.wheelchair ? "Yes" : "No"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Which best describes your activity?</p>
              <p className="text-secondary">
                It is based on {optionData?.accessTime ?? "N/A"}
              </p>
            </div>
          </div>
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Cut Off Time</p>
              <p className="text-secondary">
                {optionData?.cutOffTime ?? "N/A"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
